import config from '../config'

export const IMAGE_TYPE = {
  JPEG: 'JPEG',
  PNG: 'PNG',
}

export const getUploadImageUrl = async (type = IMAGE_TYPE.JPEG) => {
  try {
    const response = await fetch(`${config.apiGateway}/api/v1/upload/url?contentType=${type}`).then((response) =>
      response.json(),
    )

    const { url } = response.data
    return url
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getPublicUrl = (url) => {
  const arr = url.split('?')
  const data = arr[0]
  const x = data.split('/')
  const publicURL = x[0] + '//' + x[2] + '/' + x[3] + '/' + x[4]
  return publicURL
}
